<template>
	<el-drawer title="聊天历史记录" size="700px"  :visible.sync="visible" direction="rtl" :before-close="onClose">
		 
		<div class="chat-history" v-loading="loading" 
		 element-loading-text="拼命加载中">
			
			<el-scrollbar  class="chat-history-scrollbar" ref="scrollbar" id="historyScrollbar" >
				<ul>
					<li v-for="(msgInfo,idx) in messages" :key="idx">
						<chat-message-item :mode="2" :mine="msgInfo.sendId == mine.id" :headImage="headImage(msgInfo)" :showName="showName(msgInfo)"
						 :msgInfo="msgInfo" :menu="false">
						</chat-message-item>
					</li>
				</ul>
			</el-scrollbar>
		</div>
		 <!-- 添加搜索输入框 -->
		 <div class="search-container fixed-search">
            <el-input v-model="searchText" placeholder="请输入需要搜索的聊天内容" size="small" class="search-input" prefix-icon="el-icon-search" @keyup.enter.native="onSearch"></el-input>
            <el-button @click="onSearch" size="small">搜索</el-button>
        </div>
	</el-drawer>
</template>

<script>
	import ChatMessageItem from './ChatMessageItem.vue';

	export default {
		name: 'chatHistory',
		components: {
			ChatMessageItem
		},
		props: {
			visible: {
				type: Boolean
			},
			chat: {
				type: Object
			},
			friend: {
				type: Object
			},
			group: {
				type: Object
			},
			groupMembers: {
				type: Array,
			}
		},
		data() {
			return {
				page: 1,
				size: 10,
				messages: [],
				loadAll: false,
				loading: false,
				lastScrollTime: new Date(),
				// 新增搜索文本变量
            	searchText: ''
			}
		},
		methods: {
			onClose() {
				this.page = 1;
				this.messages = [];
				this.loadAll = false;
				this.searchText = '',
				this.$emit('close');
			},
			onScroll() {
				let high = this.$refs.scrollbar.$refs.wrap.scrollTop; //距离顶部的距离
				let timeDiff = new Date().getTime() - this.lastScrollTime.getTime();
				if ( high < 30 && timeDiff>500) {
					this.lastScrollTime = new Date();
					this.loadMessages();
					
				}
			},
			loadMessages() {
				if(this.loadAll){
					return this.$message.success("已到达顶部");
				}
				let param = {
					page: this.page++,
					size: this.size
				}
				if (this.chat.type == 'GROUP') {
					param.groupId = this.group.id;
				} else {
					param.friendId = this.friend.id;
				}
				param.searchText = this.searchText;
				this.loading = true;
				this.$http({
					url: this.histroyAction,
					method: 'get',
					params: param
				}).then(messages => {
					messages.forEach(m => this.messages.unshift(m));
					this.loading = false;
					if(messages.length <this.size){
						this.loadAll = true;
					}
					this.refreshScrollPos();
				}).catch(()=>{
					this.loading = false;
				})
			},
			showName(msgInfo) {
				if (this.chat.type == 'GROUP') {
					let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
					return member ? member.showNickName : "";
				} else {
					return msgInfo.sendId == this.mine.id ? this.mine.nickName : this.chat.showName
				}
			},
			headImage(msgInfo) {
				if (this.chat.type == 'GROUP') {
					let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
					return member ? member.headImage : "";
				} else {
					return msgInfo.sendId == this.mine.id ? this.mine.headImageThumb : this.chat.headImage
				}
			},
			refreshScrollPos(){
				let scrollWrap =  this.$refs.scrollbar.$refs.wrap;
				let scrollHeight = scrollWrap.scrollHeight;
				let scrollTop = scrollWrap.scrollTop;
				this.$nextTick(() => {
					let offsetTop = scrollWrap.scrollHeight - scrollHeight;
					scrollWrap.scrollTop = scrollTop + offsetTop;
					// 滚动条没出来，继续加载
					if(scrollWrap.scrollHeight == scrollHeight){
						this.loadMessages();
					}
				});
			},
			// 新增搜索方法
			onSearch() {
				this.messages = [];
				this.page = 1;
				this.loadAll = false;
				this.loadMessages();
        	}
		},
		computed: {
			mine() {
				return this.$store.state.userStore.userInfo;
			},
			histroyAction() {
				return `/message/${this.chat.type.toLowerCase()}/history`;
			}
		},
		watch: {
			visible: {
				handler(newValue, oldValue) {
					if (newValue) {
						this.loadMessages();
						this.$nextTick(() => {
							document.getElementById('historyScrollbar').addEventListener("mousewheel", this.onScroll,true);
						});
					}
				}
			}
		}
	}
</script>

<style lang="scss">
	.chat-history {
		display: flex;
		height: 100%;
		// 为了给搜索框留出空间，添加底部内边距
        padding-bottom: 60px; 
		
		.chat-history-scrollbar {
			flex: 1;
			.el-scrollbar__thumb {
			    background-color: #555555;
			}
			ul {
				padding: 20px;
				margin: 0;
				 // 隐藏横向滚动条
				 overflow-x: hidden; 
				li {
					list-style-type: none;
					margin: 0;
                    padding: 0;
				}
			}
		}
	}


	.search-container {
        display: flex;
        align-items: center;
        margin-left: 20px;
        padding-right: 20px;
        .search-input {
            flex: 1;
            margin-right: 10px;
            .el-input__inner {
                border: 1px solid #ccc;
                border-radius: 4px;
                background-color: #f9f9f9;
                color: #333;
                transition: border-color 0.3s ease;

                &:focus {
                    border-color: #409eff;
                    outline: none;
                }
            }

            .el-input__prefix {
                .el-input__icon {
                    color: #999;
                    font-size: 14px;
                }
            }

            &::placeholder {
                color: #999;
            }
        }
    }

    // 新增浮动样式
    .fixed-search {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white; // 设置背景颜色，避免内容被遮挡
        padding: 10px 20px; // 添加内边距，让搜索框更美观
        box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1); // 添加阴影，提升层次感
    }

</style>
